import { VStack, SimpleGrid, HStack, Text } from "@chakra-ui/react";
import { Display02, Paragraph02 } from "~/components/Texts";
import { FiChevronRight } from "react-icons/fi";
import { FiExternalLink } from "react-icons/fi";
import AnimatedEntryOnViewport from "~/components/animations/AnimatedEntryOnViewport";

export default function SupportSectionFaq() {
  return (
    <VStack
      maxW="1200px"
      alignSelf="center"
      spacing={{ base: "6", md: "12" }}
      pt={{ base: "10", md: "20" }}
      pb={{ base: "4", md: "10" }}
      px={{ base: "2", sm: "4", md: "6", lg: "14", xl: "16" }}
    >
      <AnimatedEntryOnViewport width="auto">
        <Display02 textAlign="center">Preguntas frecuentes</Display02>
      </AnimatedEntryOnViewport>
      <SimpleGrid
        w="100%"
        columns={{ base: 1, lg: 2 }}
        gap={{ base: "6", md: "8" }}
      >
        <Question
          question="¿Hay costos fijos o de instalación?"
          answer="No, creamos Shop Story como una plataforma para emprendedores y creemos que la forma más justa de ayudarlos es no cobrando nada antes de que vendan."
        />
        <Question
          question="¿Cómo elijo el plan para mi negocio?"
          answer="El plan de tu negocio se ajusta automáticamente según tu facturación mensual. De esta manera, podés estar tranquilo de que si te volves viral o vendés mucho en un mismo mes vas a pagar menos."
        />
        <Question
          question="Necesito ayuda, ¿tengo soporte?"
          answer="Sí. Todas las tiendas que trabajan con nosotros tienen acceso a soporte vía email, chat o dentro de nuestra comunidad. Si necesitas soporte dedicado ponete en contacto con nosotros en comercial@shopstory.io."
        />

        <Question
          question="¿Puedo trabajar en equipo?"
          answer="Sí, Shop Story es una plataforma 100% colaborativa pensada para el mundo moderno. Podés agregar tantos miembros a tu equipo como quieras."
        />
        <Question
          question="Vendí en mi local, ¿puedo registrar la venta?"
          answer="Sí. Podés cargar ventas en forma manual desde tu panel de control. Sabemos que tener tu contabilidad unificada ayuda mucho, por  eso las ventas manuales están bonificadas y no pagan costo de servicio."
        />
        <Question
          question="¿Tengo que pagar por adelantado?"
          answer="No, sólo pagás después de vender. Tenés tiempo para pagar el costo del servicio de tu tienda hasta el día 10 de cada mes."
        />
        <Question
          question="¿Cómo debo cobrar por mis ventas?"
          answer="Sos libre de vender como quieras. Shop Story no impone condiciones de venta ni métodos de pago forzados para tu negocio."
        />
        <Question
          question="¿Cómo debo enviar mis pedidos?"
          answer="Sos libre de vender como quieras. Shop Story no impone condiciones para envíos, distribución o devoluciones para tu negocio."
        />
      </SimpleGrid>
      <a href="https://shopstory.peerboard.com" target="_blank" rel="noopener">
        <HStack color="action.primary">
          <Paragraph02>
            <b>Encontrá más respuestas en nuestra comunidad</b>
          </Paragraph02>
          <Paragraph02>
            <FiExternalLink />
          </Paragraph02>
        </HStack>
      </a>
    </VStack>
  );
}

const Question = ({ question, answer }) => {
  return (
    <AnimatedEntryOnViewport animation="popIn">
      <VStack w="100%" align="flex-start">
        <HStack>
          <Text
            textStyle={{ base: "label02", sm: "label01" }}
            display="inline-block"
          >
            <FiChevronRight />
          </Text>
          <Text
            textStyle={{ base: "label02", sm: "label01" }}
            display="inline-block"
          >
            {question}
          </Text>
        </HStack>
        <Text textStyle={{ base: "paragraph03", md: "paragraph02" }}>
          {answer}
        </Text>
      </VStack>
    </AnimatedEntryOnViewport>
  );
};
